/** Assessment and report URLs contain private record or participant identifiers. */
export function isPrivateAssessmentLocation(location = ""): boolean {
  const [rawPath, query = ""] = location.split("?");
  const path = rawPath.toLowerCase().replace(/^\/(en|th|es)(?=\/)/, "");
  return /^\/(assessment[^/]*|report|respondents|guest|preview|confirm-canditate)(?:\/|$)/.test(path)
    || /(?:^|&)(?:as_id|u_id|respondent_id|respondentId)=/i.test(query);
}

// Keep the document private across error/auth redirects. The router reloads
// when entering a private route from an already tracked public document.
const privateAssessmentDocument = typeof window !== "undefined" &&
  isPrivateAssessmentLocation(window.location.pathname + window.location.search);
export function isPrivateTrackingContext(location = ""): boolean {
  return privateAssessmentDocument || isPrivateAssessmentLocation(location);
}
